<template>
  <form-field
    :label="label"
    :validation-errors="validationErrors"
    :label-for="forId"
    :help-text="helpText"
  >
    <!-- https://buefy.org/documentation/field-->
    <b-input
      v-bind="$attrs"
      :value="value"
      :id="forId"
      type="textarea"
      :size="size"
      expanded
      :placeholder="placeholder"
      @input="handleInput"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
    ></b-input>
  </form-field>
</template>

<script>
  import FormField from "./FormField";
  import {FormFieldMixin} from "./FormField.mixin";

  export default {
    name: "FormFieldTextarea",
    components: {FormField},
    mixins: [FormFieldMixin],
    props: {
      value: {},
      placeholder: {
        type: String
      },
      label: {
        type: String,
      },
      validationErrors: {
        type: [String, Array, undefined],
      },
      helpText: {
        type: String
      },
      size: {
        type: String,
        default: 'is-small'
      },
    },
    data() {
      return {
        forId: this.$utils.generateClientId(),
      }
    },
    methods: {
      handleInput(val) {
        this.$emit('input', val);
        this.$emit('change', val);
        this.$emit('selected', val);

        this.emitGlobalFieldChangeEvent();
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>
